import React, { useEffect } from "react";
import { GlobalContext } from "./Context/GlobalContext";
import "./App.css";
import "./MediaQueries.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import MuiAlert from "@material-ui/lab/Alert";

//components
// import VideoScreen from "./Components/NewFuncComponents/VideoScreen";
import VideoScreen from "./Components/VideoScreen";
import PrivateVideoScreen from "./Components/NewFuncComponents/PrivateVideoScreen";
import Wrapper from "./Components/NewFuncComponents/FuncWrapper";
import Home from "./Components/NewFuncComponents/Home";
import Search from "./Components/NewFuncComponents/SearchResultsPage";
import Subscriptions from "./Components/NewFuncComponents/Subscriptions";
import AccountSettingsPage from "./Components/NewFuncComponents/AccountSettingsPage/AccountSettingsPage";

// import Home from "./Components/Home";
import Embed from "./Components/Embed";
import Playlist from "./Components/NewFuncComponents/Playlist";
import ScheduleEmbed from "./Components/Schedule/ScheduleEmbed";

//helpers
import { lookup } from "./Helpers/companyLookup";
import { setQueryVariable, getQueryVariable } from "./Helpers/QueryString";
import { getUser } from "./Helpers/url_lookups";
import OverLay from "./Components/NewFuncComponents/Modals/OverLay";
import ResetPassword from "./Components/NewFuncComponents/ResetPassword";
import ForgotPassword from "./Components/NewFuncComponents/ForgotPassword";
import { SharingRedirect } from "./Components/Sharing/SharingRedirect";
import { BASE_PATH } from "./constants/awsBaseUrl";

const CONF_LOOKUP = "https://837sc3bew0.execute-api.us-west-2.amazonaws.com";
const HOMEPAGE = "https://2kbyogxrg4.execute-api.us-west-2.amazonaws.com";
const LOGIN_URL =
  "https://310nwnmom8.execute-api.us-west-2.amazonaws.com/login";
const VIEWS_URL = "https://m513nl9tlc.execute-api.us-west-2.amazonaws.com/";
const API_URL =
  "https://do2v45e3qi.execute-api.us-west-2.amazonaws.com/production";
const detectMobile = () => {
  return (
    window.navigator.userAgent.toLowerCase().includes("mobile") &&
    window.innerWidth < 568
  );
};

class App extends React.Component {
  static contextType = GlobalContext;
  state = {
    //url: "http://localhost:9999",
    url: "https://imd0mxanj2.execute-api.us-west-2.amazonaws.com",
    videos: [],
    search: false,
    user: { _id: "", email: "", client_secret: "" },
    recomended: [],
    type: "",
    searchTerm: "",
    company: "",
    title: "",
    refresh: Math.random() * 10000000,
    payload: { live: [], playlists: [], recent: [], subscriptions: [] },
    config: [],
    playlist: [],
    cat: undefined,
    loading: 0,
    loadingLong: 0,
    loadingError: "",
    visible: true,
    vodIdentifier: null,
    playlistOrder: undefined,
    mobileMessage: detectMobile(),
    messageDismissed: false,
  };

  dismissMobileMessage = () => this.setState({ messageDismissed: true })

  componentDidMount() {
    // need to retrieve the publicUserId before being able to auto login
    (async ()=> {
      await this.gatherAllVodData();
      this.login_init(this.state.company);
    })();
  }

  // cleaned up the redundant code that was left in the previous function
  gatherAllVodData = async (attempts=0) => {
    this.setLoading(true);
    try {
      const { 
        hideViews:hv, 
        setHideViews, 
        setOwnerOfVODId, 
        setCompanyEndpoint, 
        setConnectedStripeId 
      } = this.context;
      const vodIdentifier = getUser();

      let data;

      try {
        let req = await axios.get(`${CONF_LOOKUP}/${vodIdentifier}`);
        data = req.data
      } catch (err) {
        if(attempts < 5 && err.response?.status === 409) {
          this.setLoading(false);
          this.setState({loadingLong: true})
          return this.gatherAllVodData(attempts + 1); // Try again
        } else {
          this.setLoading(false);
          this.setState({loadingError: "Whoops, something went wrong! Please refresh the page and try again."})
          console.error(`Error fetching config:`);
          console.error(err);
          return
        }
      }
      this.setLoading(false);
      this.setState({loadingLong: false})

      let {
        user,
        company,
        color,
        title,
        webScheduleLive,
        webSchedulePrimary,
        webScheduleSecondary,
        webScheduleAvailable,
        frontPage,
        hideViews,
        playlistOrder
      } = data;

      setCompanyEndpoint(vodIdentifier);
      setOwnerOfVODId(user);
      setHideViews(hideViews? hideViews: false)

      this.setState({
        settings: data,
        domain: user,
        company,
        color,
        title,
        webScheduleLive,
        webSchedulePrimary,
        webScheduleSecondary,
        webScheduleAvailable,
        frontPage,
        vodIdentifier,
        hideViews
      });
      if (playlistOrder !== undefined) {
        this.setState({...this.state, playlistOrder});
      };

      const connectedStripeId = await axios.post(
        `${API_URL}/get-connected-stripe-id`,
        { publicUserId: user }
      );
      setConnectedStripeId(connectedStripeId.data);

      //contains the categories for each section and its videos
      const payload = {};
      const config = await Promise.all(
        frontPage.map(async (item) => {
          let data;
          // ?when does an item have a /, if never do we this?
          if (item.includes("/")) {
            const response = await axios.post(`${HOMEPAGE}/${user}/home/null`, {
              cat: item,
            });
            if (response) {
              data = response.data;
            }
          } else {
            const response = await axios.get(
              `${HOMEPAGE}/${user}/home/${encodeURIComponent(item)}`
            );
            if (response) {
              data = response.data;
            }
          }

          // Get live view counts
          //if we have data and the item that we retrieve were live streams set the view count unless zero are watching
          if (data && item === "live") {
            for (let live of data) {
              live.views = 0;
              try {
                const res = await axios.get(
                  `${VIEWS_URL}live/recent/${live._id}`
                );
                if (res.data) {
                  live.views = parseInt(res.data, 10);
                }
              } catch (err) {
                console.error(err.message);
              }
            }
          }
          payload[item] = data;
          return item;
        })
      );

      this.setState({ config });
      this.setState({ payload });
    } catch (err) {
      console.error(`Error setting config:`);
      console.error(err.message);
    }

    this.setLoading(false);
  };

  // ?why is this in its own separate function
  updateContext = async ({ viewerObj }) => {
    const { setViewerId, setViewerObj } = this.context;
    setViewerObj(viewerObj);
    setViewerId(viewerObj._id);
    this.setState({ user: viewerObj });
  };

  login_init = async () => {

    try {
      const email = localStorage.getItem("email");
      const password = localStorage.getItem("password");

      if (email && password) {
        const { data } = await axios.post(LOGIN_URL, {
          email,
          password,
          publicUserId: this.state.domain,
        });

        await this.updateContext(data);
      }
    } catch (err) {
      console.error("Error initiating login:");
      console.error(err);
    }
    setTimeout(() => this.setState({ visible: false }), 200);
  };

  // !this should be inside the playlist page and the api call should be made then and not in the parent component
  initPlaylists = async () => {
    let user = this.state.domain;
    if (!user) return false;
    let playlists = await axios.get(`${HOMEPAGE}/${user}/playlist`);
    if (playlists.data) {
      let splaylists =
        (this.state.payload && this.state.payload.playlists) || {};
      let nplaylists = {};
      for (let [key, data] of Object.entries(playlists)) {
        nplaylists[key] = { ...splaylists[key], ...playlists.data[key] };
      };
      this.setState((state) => ({
        ...state,
        payload: {
          ...state.payload,
          playlists: nplaylists,
        },
      }));
    }
  };
  // Wrap function in Wrapper with props
  wrapComponent = ({ history, match }, contents, unlisted=false) => {
    return (
      <Wrapper
        url={this.state.url}
        user={this.state.domain}
        payload={this.state.payload}
        pub_user={this.state.user}
        color={this.state.color}
        title={this.state.title}
        unlisted={unlisted}
        company={match.params.company}
        shouldRegister={this.state.shouldRegister}
        clearRegister={() => this.setState({ shouldRegister: false })}
        logout={() => {
          const { setViewerId, setViewerObj } = this.context;
          this.setState({ user: { _id: "", email: "" } });
          localStorage.removeItem("email");
          localStorage.removeItem("password");
          setViewerId(null);
          setViewerObj(null);
        }}
        login={(user, creds) => {
          this.setState({ user });
          localStorage.setItem("email", creds.email);
          localStorage.setItem("password", creds.password);
        }}
        home={() => {
          this.setState({ search: false });
          history.push("/" + match.params.company + "/");
        }}
        setVideos={(videos, bool, search) => {
          history.push("/" + match.params.company + "/");
          this.setState({
            videos,
            search: true,
            searchTerm: search,
          });
        }}
        navigatePage={(page) => {
          this.setState({ search: false });
          history.push(`/${match.params.company}/?page=${page}`);
        }}
      >
        {contents}
      </Wrapper>
    );
  };

  fetchPlaylist = async (name) => {
    try {
      let { domain } = this.state;
      let response = await axios.get(
        `${HOMEPAGE}/${domain}/playlist/${encodeURIComponent(name)}`
      );
      if (response) {
        let { data } = response;
        this.setState((state) => ({
          ...state,
          payload: {
            ...state.payload,
            playlists: state.payload.playlists
              .filter((list) => list)
              .map((list) => {
                if (data && list._id === data._id) {
                  return data;
                } else {
                  return list;
                }
              }),
          },
        }));
        const { playlists } = this.state.payload;
        const playlistRes = playlists.sort((a, b) => {
          const aIndex = typeof a?.index === 'number' ? a.index : Infinity;
          const bIndex = typeof b?.index === 'number' ? b.index : Infinity;
          return aIndex - bIndex
        });
        this.setState({
          ...this.state,
          payload: {
            ...this.state.payload,
            playlists: playlistRes
          }
        });
        return data;
      }
    } catch (err) {
      console.error("Error fetching playlist:");
      console.error(err);
    }
    return null;
  };

  goToPlaylist = async ({ history, match, location }, name) => {
    this.setLoading(true);
    try {
      let data = await this.fetchPlaylist(name);
      if (data) {
        let file = data.videos[0];
        let recomended = data.videos;
        this.setState((state) => ({
          ...state,
          file,
          recomended,
          type: "playlist",
        }));
        history.push(
          `/${match.params.company}/video/${file?._id}${location.search}`
        );
      }
    } catch (err) {
      console.error("Error navigating to playlist:");
      console.error(err);
    }
    this.setLoading(false);
  };

  setLoading = (loading) => {
    if (loading) {
      this.setState((state) => ({ ...state, loading: state.loading + 1 }));
    } else {
      this.setState((state) => ({
        ...state,
        loading: Math.max(state.loading - 1, 0),
      }));
    }
  };

  /*
   * SUBSCRIPTION PAGE
   */

  render() {

    if(this.state.loadingError) {
      return (
        <div className={this.state.loadingError ? "full-screen-modal" : "d-none"}>
          <MuiAlert severity="error" variant="filled">{this.state.loadingError}</MuiAlert>
        </div>
      )
    }

    return (
      <div className={this.context.darkMode?'dark vh app-container':"app-container"}>
        <Helmet>
          <link
            rel="icon"
            href={`${BASE_PATH}/icons/${this.state.domain}/banner.jpg?refresh=${this.state.refresh}`}
          />
          <title>
            {/* {getUser().toUpperCase() + " VOD"} */}
            {this.state.title}
          </title>
        </Helmet>
        <OverLay visible={this.state.loading} text={this.state.loadingLong > 0 ?
          "Something went wrong. Retrying..." :
          undefined
        }/>;

        <Router basename="/vod">
          <Switch>
            <Route
              path={`/${this.state.vodIdentifier}/account`}
              render={() => <AccountSettingsPage />}
            />

            <Route 
              path={"/:company/private/:video"}
              render={({ history, location, match }) => {
                if (getQueryVariable("page", location)) {
                  const unlisted = true;
                  return this.wrapComponent(
                    { history, match },
                    <PrivateVideoScreen
                      register={() => this.setState({ shouldRegister: true })}
                      video={match.params.video}
                      file={this.state.file}
                      url={this.state.url}
                      user={this.state.domain}
                      color={this.state.color}
                      pub_user={this.state.user}
                    />,
                    unlisted
                  );
                }
                else history.push(setQueryVariable("page", "HOME", location));
              }}
            />

            <Route
              path="/:company/playlist/:playlist"
              render={({ history, location, match }) => {
                let locationValue =
                  location.pathname.split("/")[
                    location.pathname.split("/").length - 1
                  ];
                if (getQueryVariable("page", location)) {
                  return this.wrapComponent(
                    { history, match },
                    <Playlist
                      register={() => {
                        this.setState({ shouldRegister: true });
                      }}
                      url={this.state.url}
                      user={this.state.domain}
                      pub_user={this.state.user}
                      playlist={this.state.playlist}
                      playlistName={match.params.playlist}
                      company={match.params.company}
                      cat={locationValue}
                      setFile={(file) => {
                        this.setState({ file });
                        history.push(
                          `/${match.params.company}/video/${file._id}`
                        );
                      }}
                      type={this.state.type}
                      color={this.state.color}
                    />
                  );
                } else {
                  history.push(setQueryVariable("page", "HOME", location));
                }
              }}
            />

            <Route
              path="/:company/embed/playlist/:playlist"
              render={({ history, location, match }) => {
                let locationValue =
                  location.pathname.split("/")[
                    location.pathname.split("/").length - 1
                  ];
                if (getQueryVariable("page", location))
                  return (
                    <Playlist
                      register={() => {
                        this.setState({ shouldRegister: true });
                      }}
                      url={this.state.url}
                      user={this.state.domain}
                      pub_user={this.state.user}
                      playlist={this.state.playlist}
                      playlistName={match.params.playlist}
                      company={match.params.company}
                      cat={locationValue}
                      setFile={(file) => {
                        this.setState({ file });
                        history.push(
                          `/${match.params.company}/video/${file._id}`
                        );
                      }}
                      type={this.state.type}
                      color={this.state.color}
                    />
                  );
                else history.push(setQueryVariable("page", "HOME", location));
              }}
            />

            {/* renders the video page */}
            <Route
              path="/:company/video/:video"
              render={({ history, location, match }) => {
                if (getQueryVariable("page", location))
                  return this.wrapComponent(
                    { history, match },
                    <VideoScreen
                      register={() => this.setState({ shouldRegister: true })}
                      video={match.params.video}
                      file={this.state.file}
                      url={this.state.url}
                      user={this.state.domain}
                      recomended={this.state.recomended}
                      setFile={(file) => {
                        this.setState({ file });
                        history.push(
                          `/${match.params.company}/video/${file._id}`
                        );
                      }}
                      type={this.state.type}
                      color={this.state.color}
                      webScheduleLive={this.state.webScheduleLive}
                      webSchedulePrimary={this.state.webSchedulePrimary}
                      webScheduleSecondary={this.state.webScheduleSecondary}
                      webScheduleAvailable={this.state.webScheduleAvailable}
                      downloadsDisabled={
                        this.state.settings
                          ? this.state.settings.downloadsDisabled
                          : false
                      }
                      // commentsDisabled={
                      //   this.state.settings
                      //     ? this.state.settings.commentsDisabled
                      //     : false
                      // }
                      commentsDisabled={true}
                      pub_user={this.state.user}
                    />
                  );
                else history.push(setQueryVariable("page", "HOME", location));
              }}
            />

            <Route
              path="/:company/search"
              render={async ({ history, location, match }) => {
                if (getQueryVariable("q", location)) {
                  let search = getQueryVariable("q", location);
                  axios
                    .post(this.state.url + "/upload/search", {
                      _id: await lookup(match.params.company),
                      search,
                    })
                    .then((res) => {
                      history.push(`${match.params.company}`);
                      this.setState({
                        videos: res.data.response.payload.files,
                        search: true,
                        searchTerm: search,
                      });
                    });
                } else {
                  history.push(`${match.params.company}`);
                }
                return this.wrapComponent(
                  { history, match },
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                      padding: "25%",
                    }}
                  >
                    <i class="fas fa-spinner fa-2x "></i>
                  </div>
                );
              }}
            />
            <Route
              path="/:company/embed/schedule/:_id"
              render={({ history, match }) => {
                return (
                  <ScheduleEmbed
                    id={match.params._id}
                    user={this.state.domain}
                    color={this.state.color}
                    webScheduleLive={this.state.webScheduleLive}
                    webSchedulePrimary={this.state.webSchedulePrimary}
                    webScheduleSecondary={this.state.webScheduleSecondary}
                    webScheduleAvailable={this.state.webScheduleAvailable}
                  />
                );
              }}
            />

            <Route
              path="/:company/embed/search"
              render={({ history, location, match }) => {
                if (
                  getQueryVariable("q", location) &&
                  this.state.videos.length === 0
                ) {
                  let search = getQueryVariable("q", location);
                  axios
                    .post(this.state.url + "/upload/search", {
                      _id: lookup(match.params.company),
                      search,
                    })
                    .then((res) => {
                      this.setState({
                        videos: res.data.response.payload.files,
                        search: true,
                        searchTerm: search,
                      });
                    });
                }
                if (this.state.videos.length)
                  return (
                    <Search
                      color={this.state.color}
                      user={this.state.domain}
                      url={this.state.url}
                      videos={this.state.videos}
                      search={this.state.searchTerm}
                      setFile={(file) => {
                        history.push(
                          "/" + match.params.company + "/embed/" + file._id
                        );
                      }}
                    />
                  );
                else
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        padding: "25%",
                      }}
                    >
                      <i class="fas fa-spinner fa-2x "></i>
                    </div>
                  );
              }}
            />

            <Route
              path="/:company/embed/category"
              render={({ history, location, match }) => {
                axios
                  .post(this.state.url + "/embed/get", {
                    type: getQueryVariable("category", location),
                    index: getQueryVariable("index", location),
                    user: getQueryVariable("user", location),
                  })
                  .then((res) => {
                    if (res.data.response.success) {
                      history.push(
                        "/" +
                          match.params.company +
                          "/embed/" +
                          res.data.response.payload.data +
                          `?embedID=${getQueryVariable("embedID", location)}`
                      );
                    }
                  });
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                      padding: "25%",
                    }}
                  >
                    <i class="fas fa-spinner fa-2x "></i>
                  </div>
                );
              }}
            />

            <Route
              path="/:company/embed/:video"
              render={({ history, location, match }) => {
                return (
                  <Embed
                    video={match.params.video}
                    color={this.state.color}
                    user={this.state.domain}
                    pub_user={this.state.user}
                    url={this.state.url}
                    embedID={getQueryVariable("embedID", location)}
                    showDetails={getQueryVariable("showDetails", location)}
                  />
                );
              }}
            />

            {/* main route that loads homepage */}
            <Route
              path="/:company/"
              render={({ history, location, match }) => {
                if (location.pathname.split("/").at(-1) == "subscriptions") {
                  return <Subscriptions companyName={match.params.company} />;
                } else if (
                  location.pathname.split("/").at(-1) == "reset-password"
                ) {
                  return <ResetPassword companyName={match.params.company} />;
                } else if (
                  location.pathname.split("/").at(-1) == "forgot-password"
                ) {
                  return <ForgotPassword companyName={match.params.company} />;
                } else {
                  if (getQueryVariable("page", location)) {
                    return this.wrapComponent(
                      { history, match },
                      this.state.search ? (
                        <Search
                          color={this.state.color}
                          videos={this.state.videos}
                          searchTerm={this.state.searchTerm}
                          viewerObj={this.state.user}
                          setFile={(file) => {
                            this.setState({ file });
                            history.push(
                              `/${match.params.company}/video/${file._id}`
                            );
                          }}
                        />
                      ) : (
                        <Home
                          payload={this.state.payload}
                          config={this.state.config}
                          register={() => this.setState({ shouldRegister: true })}
                          refresh={this.state.refresh}
                          color={this.state.color}
                          user={this.state.domain}
                          fetchPlaylist={this.fetchPlaylist}
                          initPlaylists={this.initPlaylists}
                          setFile={(file, recomended, type, notAccessible) => {
                            // notify the user to login if the video is behind a paywall
                            if(notAccessible && !this.state.user._id) return this.setState({ shouldRegister: true });

                            if (type === "playlist-first") {
                              this.goToPlaylist(
                                { history, match, location },
                                file
                              );
                            } else {
                              this.setState({ file, recomended, type });
                              history.push(
                                `/${match.params.company}/video/${file?._id}${
                                  location.search
                                }${type === "live" ? `&type=${type}` : ""}`
                              );
                            }
                          }}
                          setPlaylist={(playlist, cat) => {
                            this.setState({ playlist, cat });
                            history.push(
                              `/${match.params.company}/playlist/${cat}${location.search}`
                            );
                          }}
                        />
                      )
                    );
                  } else {
                    let redirectTo = setQueryVariable("page", "HOME", location);
                    return <Redirect to={redirectTo} />;
                  }
                }
              }}
            />

            <Route
              path="/"
              render={({ history, location, match }) => {
                // Redirect to remove the hash, for the benfit of pre-existing urls
                if (location.hash) {
                  let newPath = location.hash.slice(1);
                  if (!newPath.startsWith("/")) {
                    newPath = "/" + newPath;
                  }
                  return <Redirect to={newPath} />;
                } else {
                  return <Redirect to="/castus-training/" />;
                }
              }}
            />
          </Switch>
        </Router>

        {/*Mobile message to rotate screen*/}
        <SharingRedirect mobileStatus={this.state.mobileMessage} dismissMobileMessage={this.dismissMobileMessage} messageDismissed={this.state.messageDismissed} />

        {/* <div
          className={this.state.mobileMessage ? "rotate-message" : "d-none"}
        >
          <div className="rotate-message-body">
            Please rotate your screen for better viewing experience
          </div>
          <div
            className="rotate-message-close"
            onClick={() => this.setState({ mobileMessage: false })}
          >
            close
          </div>
        </div> */}
      </div>
    );
  }
}

export default App;

/*const TEST_DATA = JSON.parse('[{"_id":"62042a02e4dc290008efc696","name":"Appropriations Subcommittee","date":"2022-05-17T19:34:31.019Z"},{"_id":"61f851ee9f3a240008406746","name":"Oversight","date":"2022-05-17T19:31:11.239Z"},{"_id":"61f95f15a971d200087b3e0b","name":"Senate Session","date":"2022-05-17T17:27:08.860Z"},{"_id":"61f85126e760be0008c00097","name":"Education and Career Readiness","date":"2022-05-17T16:51:06.205Z"},{"_id":"61f851c050f611000802ccbb","name":"Judiciary and Public Safety","date":"2022-05-17T13:59:07.606Z"},{"_id":"61f8519d9f3a2400084065db","name":"Health Policy and Human Services","date":"2022-05-12T20:11:02.603Z"},{"_id":"61f851146967e00008fd8337","name":"Economic and Small Business Development","date":"2022-05-12T18:49:02.127Z"},{"_id":"61f850ee42fc920008885764","name":"Agriculture","date":"2022-05-12T14:32:08.991Z"},{"_id":"61f8510c22064a0008a8b78c","name":"Appropriations","date":"2022-05-11T19:39:16.322Z"},{"_id":"61f851fe50f611000802cd57","name":"Transportation and Infrastructure","date":"2022-05-11T17:34:03.643Z"},{"_id":"61f851f450f611000802cd39","name":"Regulatory Reform","date":"2022-05-10T20:24:33.297Z"},{"_id":"61f851da94bb900008bfb180","name":"Local Government","date":"2022-05-10T16:31:58.641Z"},{"_id":"61f8513494bb900008bfb046","name":"Elections","date":"2022-05-04T18:22:37.858Z"},{"_id":"61f8514b31adc2000870bb2e","name":"Environmental Quality","date":"2022-05-04T17:54:25.565Z"},{"_id":"61f8518d33f70a0008047163","name":"Finance","date":"2022-04-20T17:36:39.385Z"},{"_id":"61f851e47ba8480008b17798","name":"Natural Resources","date":"2022-03-23T14:58:19.301Z"},{"_id":"621e689c8312df000823c521","name":"Miscellaneous","date":"2022-03-22T13:36:51.449Z"},{"_id":"61f851b5e4c10f0008d70eb0","name":"Insurance and Banking","date":"2022-03-03T21:20:10.451Z"},{"_id":"61f85194e760be0008c001b0","name":"Government Operations","date":"2022-03-02T20:55:59.330Z"},{"_id":"61f851777ba8480008b1764b","name":"Families, Seniors, and Veterans","date":"2022-03-02T20:00:24.296Z"},{"_id":"61f8513c42fc9200088857b2","name":"Energy and Technology","date":"2022-03-02T19:50:41.480Z"},{"_id":"61f850656967e00008fd82ea","name":"Advice and Consent","date":"2022-02-24T21:18:25.380Z"}]')*/
